module.exports = __webpack_public_path__ + "img/video-5.782eb8ac.png";